export default {
	title: 'परिदृश्य',
	subtitle: 'सभी संभावित परिदृश्य सूचीबद्ध करें जिनका आप मूल्यांकन करेंगे',
	no_description: 'कोई विवरण नहीं',

	context_worse: 'नकारात्मक',
	context_best: 'सकारात्मक',

	tabs: {
		list: 'सूची',
		details: 'विवरण',
		visualization: 'दृश्यीकरण',
		alt_title: 'संश्लेषण'
	}
};
